import actions from "./actions";
import { getEngagementDesignState } from "./state";
import mutations from "./mutations";
import getters from "./getters";

const engagementDesignStore = {
  state: getEngagementDesignState(),
  mutations,
  actions,
  getters,
};

export default engagementDesignStore;
